import utils from '../utils/utils'
import anime from '../libs/anime'
import globalVar from '../utils/globalVar'

class Footer {
  constructor() {
      let cache = {};
      let scrollPos = window.pageYOffset;
      let imgArray = [];
      let randImgArray = [];
      let sizeW = 0;
      let sizeH = 0;
      let gap = 0;
      const nbRow = 6;
      let initFunc = () => {
        initCache();
        resize();
        window.onresize = resize;
        scrollDetect();
        window.addEventListener('scroll', scrollDetect);
      }
  
      let initCache = () => {
        cache.footer = document.querySelector('footer');
        cache.secTransition = document.querySelector('.transition-footer_container');
        cache.transition = cache.secTransition.querySelector('.transition_footer');
        cache.img1 = cache.secTransition.querySelector('.img_sample1');
        cache.img2 = cache.secTransition.querySelector('.img_sample2');
        const sec = document.querySelectorAll('section');
        if(sec[sec.length - 1].classList.contains('bg_white')) {
            cache.img2 = cache.secTransition.querySelector('.img_sample2_white');   
        }
      };

      let resize = () => {
        imgArray = [];
        cache.transition.innerHTML = "";
        if(globalVar.desktop.matches) {
            sizeW = 73;
            sizeH = 78;
            gap = 35;
        }
        else {
            sizeW = 38;
            sizeH = 40;
            gap = 20;
        }
        initImg();
      };

      let initImg = () => {
        const nbImg = ((Math.ceil(window.innerWidth/(sizeW+gap)))*2)+2;
        for (let iRow = 0; iRow < nbRow; iRow++) {
            let div = document.createElement('div');
            div.classList.add('row');
            for (let iImg = 0; iImg < nbImg; iImg++) {
                if(iRow % 2) {
                    let img = document.createElement('img');
                    if(iImg % 2) {
                        img.src = cache.img2.src;
                        img.classList.add('img_odd');
                    } else {
                        img.src = cache.img1.src;
                    }
                    img.classList.add('row_odd'); 
                    div.appendChild(img);
                } else {
                    let img = document.createElement('img');
                    if(iImg % 2) {
                        img.src = cache.img1.src;
                        img.classList.add('img_odd');
                    } else {
                        img.src = cache.img2.src;
                    }
                    div.appendChild(img);
                }
            }
            cache.transition.appendChild(div);
        }

        imgArray = Array.from(document.querySelectorAll('.transition-footer_container .transition_footer img'));
        randImgArray = shuffle(imgArray);
        
      };

      let scrollDetect = function() {
        scrollPos = window.pageYOffset;

        if(((scrollPos + window.innerHeight) > (cache.footer.offsetTop - 78)) && ((scrollPos + window.innerHeight) < ((cache.footer.offsetTop) + cache.secTransition.offsetHeight)) ) {
            if(cache.transition.classList.contains('completed')) {
                cache.transition.classList.remove('completed');
            }
            let pos = ( ((scrollPos + window.innerHeight)-(cache.footer.offsetTop - 78)) / (cache.secTransition.offsetHeight + 78));
            for (let i = randImgArray.length-1; i >= 0; i--) {
                let lineInnerAnime =  anime({
                    targets: randImgArray[i],
                    opacity: [1,0],
                    delay: 10 * i,
                    duration: 1000,
                    easing: 'linear',
                    autoplay: false,
                    complete: function() {
                        if(i == 0) {
                            cache.transition.classList.add('completed');
                        }
                    }
                }) 
            
                lineInnerAnime.seek((pos *(1 + i/100)+0.01) * lineInnerAnime.duration);
                            
            }

            // let moveSec =  anime({
            //     targets: cache.secTransition,
            //     translateY: ['0%', '-10%'],
            //     duration: 1000,
            //     easing: 'linear',
            //     autoplay: false,
            // }) 
        
            // moveSec.seek(pos* moveSec.duration);
        }

        if(((scrollPos + window.innerHeight) < (cache.footer.offsetTop)) && (cache.transition.classList.contains('completed'))) {
            cache.transition.classList.remove('completed');
            randImgArray.forEach(img => {
                anime({
                    targets: img,
                    opacity: 1,
                    duration: 400,
                    easing: 'linear',
                }) 
            });
        }

        if(((scrollPos + window.innerHeight) > ((cache.footer.offsetTop) + cache.secTransition.offsetHeight)) && (!cache.transition.classList.contains('completed'))) {
            cache.transition.classList.add('completed');
            cache.transition.classList.add('completed-mobile');
            randImgArray.forEach(img => {
                anime({
                    targets: img,
                    opacity: 0,
                    duration: 400,
                    easing: 'linear',
                }) 
            });
        }
      }



      function shuffle(array) {
            let currentIndex = array.length,  randomIndex;
    
            // While there remain elements to shuffle...
            while (currentIndex != 0) {
    
            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;
    
            // And swap it with the current element.
            [array[currentIndex], array[randomIndex]] = [
                array[randomIndex], array[currentIndex]];
            }
    
            return array;
        }
    initFunc();
  };
}
export { Footer }
